import { useMemo } from 'react';
import { type NavGroup, navGroups, routes } from '@/shared/config';
import { canAccess, isWhatsAppOnly } from './access';
import { useSessionUser } from './session-store';

/** Navigation filtered by the signed-in user's role and permissions. */
export function useVisibleNav(): NavGroup[] {
  const user = useSessionUser();

  return useMemo(() => {
    if (isWhatsAppOnly(user)) {
      return navGroups
        .map((g) => ({ ...g, items: g.items.filter((i) => i.path === routes.whatsappLogs) }))
        .filter((g) => g.items.length > 0);
    }
    return navGroups
      .map((g) => ({ ...g, items: g.items.filter((i) => canAccess(user, i.access)) }))
      .filter((g) => g.items.length > 0);
  }, [user]);
}
